/**
 * The designer's top-level views. The route validates its `view` search param
 * against this list and the header renders the switcher from it.
 */
export const EDITOR_VIEWS = ['build', 'flow', 'logic', 'settings', 'source'] as const;

export type EditorView = (typeof EDITOR_VIEWS)[number];

/** The views the header switcher offers; `source` sits under Settings. */
export const SWITCHER_VIEWS = ['build', 'flow', 'logic', 'settings'] as const;
export type SwitcherView = (typeof SWITCHER_VIEWS)[number];

/** Which switcher entry a view belongs to. */
export function switcherViewFor(view: EditorView): SwitcherView {
    return view === 'source' ? 'settings' : view;
}

export function isEditorView(value: unknown): value is EditorView {
    return typeof value === 'string' && (EDITOR_VIEWS as readonly string[]).includes(value);
}
